import { SelectIF } from '@/types/common';
import ImgAbstract from '@/assets/images/prints/abstract.jpg';
import ImgAnimalPrint from '@/assets/images/prints/animalPrint.jpg';
import ImgCamouflage from '@/assets/images/prints/camouflage.jpg';
import ImgCheck from '@/assets/images/prints/check.jpg';
import ImgFloral from '@/assets/images/prints/floral.jpg';
import ImgGeometric from '@/assets/images/prints/geometric.jpg';
import ImgLogo from '@/assets/images/prints/logo.jpg';
import ImgPolkaDot from '@/assets/images/prints/polkaDot.jpg';
import ImgSolid from '@/assets/images/prints/solid.jpg';
import ImgStripe from '@/assets/images/prints/stripe.jpg';
import ImgTextPrint from '@/assets/images/prints/textPrint.jpg';

export type PatternT =
    | 'Solid'
    | 'Stripe'
    | 'Check'
    | 'Floral'
    | 'Geometric'
    | 'Abstract'
    | 'Camouflage'
    | 'AnimalPrint'
    | 'PolkaDot'
    | 'Logo'
    | 'TextPrint';

export const PATTERNS_PROPERTIES: SelectIF<PatternT>[] = [
    {
        value: 'Solid',
        label: 'Однотонный',
        settings: {
            image: ImgSolid,
        },
    },
    {
        value: 'Stripe',
        label: 'Полоска',
        settings: {
            image: ImgStripe,
        },
    },
    {
        value: 'Check',
        label: 'Клетка',
        settings: {
            image: ImgCheck,
        },
    },
    {
        value: 'Floral',
        label: 'Цветочный',
        settings: {
            image: ImgFloral,
        },
    },
    {
        value: 'Geometric',
        label: 'Геометрический',
        settings: {
            image: ImgGeometric,
        },
    },
    {
        value: 'Abstract',
        label: 'Абстрактный',
        settings: {
            image: ImgAbstract,
        },
    },
    {
        value: 'Camouflage',
        label: 'Камуфляж',
        settings: {
            image: ImgCamouflage,
        },
    },
    {
        value: 'AnimalPrint',
        label: 'Анималистичный',
        settings: {
            image: ImgAnimalPrint,
        },
    },
    {
        value: 'PolkaDot',
        label: 'Горох',
        settings: {
            image: ImgPolkaDot,
        },
    },
    {
        value: 'Logo',
        label: 'Логотип',
        settings: {
            image: ImgLogo,
        },
    },
    {
        value: 'TextPrint',
        label: 'Принт с надписями',
        settings: {
            image: ImgTextPrint,
        },
    },
];
